// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8394) return "static/chunks/8394-84b203274d663519.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5647 ? "ca377847" : chunkId) + "." + {"942":"687a16a3e759ac51","5612":"2607b791fe09fbe5","5647":"ac87ef8c610562f3","7906":"ed3f8374da74c359","9664":"856e5d641339e8a7","9967":"6597c454deaf5e9f"}[chunkId] + ".js";
};